/**
 * Created by rickborst on 24/04/2017.
 */

import _ from 'lodash';

import Image from 'models/image';
import Asset from './asset';

const RailTypes = {
    LANDSCAPE: 'LANDSCAPE',
    LANDSCAPE_MORE: 'LANDSCAPE_MORE',
    LANDSCAPE_ALL_CHANNELS: 'LANDSCAPE_ALL_CHANNELS',
    PORTRAIT: 'PORTRAIT',
    GRID_PORTRAIT: 'GRID_PORTRAIT',
    GRID_PORTRAIT_FILTER: 'GRID_PORTRAIT_FILTER',
    GRID_LANDSCAPE: 'GRID_LANDSCAPE',
    MATCH_SCHEDULE: 'MATCH_SCHEDULE',
    SPORTS: 'SPORTS',
    LEAGUES: 'LEAGUES',
    JUMBO: 'JUMBO',
    MINI_EPG: 'MINI_EPG',
    EPG: 'EPG',
    UNKNOWN: 'UNKNOWN'
};

class Rail {

    /**
     * Constructs the model.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {

        this.id = options.id || '';
        this.title = options.title || '';
        this.images = _.map(options.images || [], data => {
            return new Image(data);
        });
        this.type = options.type || '';
        this.more = options.more || '';
        this.assets = _.map(options.assets || [], data => {
            return new Asset(data);
        });
        this.pagination = {
            pageSize: _.get(options, ['pagination', 'currentPage']) || 0,
            totalAssetsCount: _.get(options, ['pagination', 'totalAssetsCount']) || 0
        };
        this.apiSpecifics = options.apiSpecifics || {};

        return this;
    }

    setPageSize (pageSize) {
        this.pagination.pageSize = pageSize;
    }

    setTotalAssetsCount (assetsCount) {
        this.pagination.totalAssetsCount = assetsCount;
    }
}

export default Rail;
export {RailTypes};


// WEBPACK FOOTER //
// ./src/js/models/rail.js